// セッションストレージからフラグを取得
const isFirstVisit = sessionStorage.getItem('isFirstVisit');
const searchParams = new URLSearchParams(window.location.search);
let hasFilterParam = false;
for (const key of searchParams.keys()) {
  if (key.startsWith('filter.')) {
    hasFilterParam = true;
    break;
  }
}
// フラグがない場合（初回アクセス時）
if (!isFirstVisit && !hasFilterParam) {
  // 初回アクセス時の処理
  document.getElementById('first-visit-animation').style.display = 'block';
  window.setTimeout(() => {
    // フェードアウトのためのclass追加
    document.getElementById('first-visit-animation').classList.add('fade-out');
    document.querySelector('#first-visit-animation img').classList.add('fade-out');

    // 画像を先にフェードアウト
    window.setTimeout(() => {
      document.querySelector('#first-visit-animation img').style.display = 'none';
    }, 800)

    // 背景のフェードアウト
    window.setTimeout(() => {
      document.getElementById('first-visit-animation').style.display = 'none';
      // セッションストレージにフラグを保存
      sessionStorage.setItem('isFirstVisit', true);
    }, 2000)
  }, 2300);
} else {
  document.getElementById('first-visit-animation').style.display = 'none';
}
